
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductBillingItemSpecificationsDialog extends Serenity.EntityDialog<ProductBillingItemSpecificationsRow, any> {
        protected getFormKey() { return ProductBillingItemSpecificationsForm.formKey; }
        protected getIdProperty() { return ProductBillingItemSpecificationsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductBillingItemSpecificationsRow.localTextPrefix; }
        protected getService() { return ProductBillingItemSpecificationsService.baseUrl; }
        protected getDeletePermission() { return ProductBillingItemSpecificationsRow.deletePermission; }
        protected getInsertPermission() { return ProductBillingItemSpecificationsRow.insertPermission; }
        protected getUpdatePermission() { return ProductBillingItemSpecificationsRow.updatePermission; }

        protected form = new ProductBillingItemSpecificationsForm(this.idPrefix);
        private loadedState: string;

        constructor() {
            super();

            this.form.EAdjustmentType.changeSelect2(e => {
                var eEAdjustmentType = this.form.EAdjustmentType.value;

                if (Q.isEmptyOrNull(eEAdjustmentType)) {
                    // this.setProductDetails({});
                    this.form.PriceAdjustment.getGridField().toggle(false);

                }
                else {

                    if (eEAdjustmentType == '1' || eEAdjustmentType == '2' || eEAdjustmentType == '3') {

                        if (eEAdjustmentType == '1') {
                            this.form.PriceAdjustment.getGridField().toggle(false);
                        }
                        else {
                            this.form.PriceAdjustment.getGridField().toggle(true);
                        }
                    }

                }

            });
        }

        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }
        loadEntity(entity: ProductsRow) {
            super.loadEntity(entity);

            if (this.isNew()) {
                this.form.PriceAdjustment.getGridField().toggle(true);
            }
            else {

                var EAdjustmentType = this.form.EAdjustmentType.value;

                if (Q.isEmptyOrNull(EAdjustmentType)) {
                    // this.setProductDetails({});
                    this.form.PriceAdjustment.getGridField().toggle(true);

                }
                else {

                    if (EAdjustmentType == '1' || EAdjustmentType == '2' || EAdjustmentType == '3') {

                        if (EAdjustmentType == '1') {
                            this.form.PriceAdjustment.getGridField().toggle(true);
                        }
                        else {
                            this.form.PriceAdjustment.getGridField().toggle(false);
                        }
                    }

                }
            }

        }

    }
}
